import { render, staticRenderFns } from "./InlineGoalList.vue?vue&type=template&id=19dc80c4&"
import script from "./InlineGoalList.vue?vue&type=script&lang=js&"
export * from "./InlineGoalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports